export const messages = {
  es: {
    message: {
      loading: {
        info: 'Cargando recursos, por favor espere un momento...'
      },
      start: {
        connectionDisconected: 'Sin conexión',
        connectionRecovered: 'Vuelve a tener conexión',
        connectionLost: 'Ha perdido la conexión',
        roomEnded: 'Vídeo consulta finalizada.'
      },
      waiting: {
        date: 'Fecha',
        startTime: 'Hora de inicio',
        endTime: 'Hora de fin',
        welcomeAlert:
          'Al unirse se le pedirá permiso para utilizar la cámara y el micrófono, es preciso aceptarlos para poder realizar la video consulta. Cargue la batería antes de iniciar la llamada.',
        compatibilityAlert:
          'Su navegador no es compatible con el sistema de consultas. Consulte la ayuda.',
        roomEnded:
          'Esta vídeo consulta ha sido finalizada por el {role}. Si necesita una nueva cita, por favor contacte con su centro médico.',
        join: 'Unirse',
        delayRoom: 'Atrasar',
        connectionMaybeLost: 'Parece haber perdido la conexión'
      },
      switching: {
        date: 'Fecha',
        startTime: 'Hora de inicio',
        endTime: 'Hora de fin',
        message: 'Puede cambiar de dispositivo'
      },
      help: {
        header: 'Ayuda',
        audioVideoHelp: {
          title: '¿Cómo activar permisos de vídeo y audio?',
          step1:
            'Haga click sobre el candado que aparece en la barra de navegación.',
          step2: 'Se mostrará un cuadro de información como el siguiente:',
          step3:
            'Si la cámara, micrófono o sonido está bloqueado o denegado, haga click sobre "Configuración del sitio web" y accederá a la siguiente vista:',
          step4:
            'A continuación haga clic sobre el elemento que está bloqueado y permita su uso.',
          step5: 'Vuelva atrás y entre en la sala de nuevo.'
        },
        browserCompatibility: {
          title: 'Compatibilidad de navegadores'
        }
      },
      videoCall: {
        doctor: 'Facultativo',
        patient: 'Paciente',
        guest: 'Invitado',
        system: 'Sistema',
        roomExpired: 'La sala ha expirado',
        roomClosedByDoctor: 'La sala ha sido cerrada por el facultativo',
        roomClosedByPatient: 'La sala ha sido cerrada por el paciente',
        userDisconnected: '{role} desconectado',
        userClosed: '{role} ha cerrado',
        comunicationLost: 'Se ha perdido la comunicación con {role}',
        notAllowedToJoin: 'No puede entrar en la sala',
        disconnected: 'Has perdido la conexión',
        closeRoom: 'Has cerrado la sala',
        disconnectRoom: 'Has salido de la sala',
        unexpectedError: 'Error inesperado',
        connectionError:
          'No se ha podido establecer la conexión. Intente de nuevo.',
        graceAlert:
          'La hora de la cita ha finalizado. Quedan {remainingMinutes} minutos de cortesía',
        audioPermissionDenied:
          'Ha denegado los permisos de audio. Visite la ayuda para solucionarlo.',
        videoPermissionDenied:
          'Ha denegado los permisos de vídeo. Visite la ayuda para solucionarlo.',
        permissionsDenied:
          'Ha denegado los permisos de audio o vídeo. Visite la ayuda para solucionarlo.',
        doctorMustHaveVideo:
          'Para poder acceder como facultativo debe tener vídeo',
        peerWithOnlyAudio: '{role} está conectado sin vídeo',
        localTag: 'Tú',
        waitHeader: 'Por favor, espere un momento',
        waitText: 'Conectando su sesión'
      },
      delayNotification: {
        header: 'Notificación de retraso',
        selectMinutes: 'Seleccione los minutos de retraso',
        send: 'Enviar notificación',
        delayMessageSent: 'La notificación de retraso ha sido enviada',
        doctorDelayMessage:
          'La video consulta lleva {minutes} minutos de retraso. Por favor permanezca atento y disculpe las molestias.'
      },
      fileSharing: {
        header: 'Compartir ficheros',
        fileSent: 'Fichero {fileName} enviado',
        fileReceived: 'Fichero {fileName} recibido',
        thereAreNoFiles: 'No hay ficheros',
        fileTooLarge: 'El fichero ha superado el límite de {fileSizeLimit} MB'
      },
      chat: {
        header: 'Chat',
        placeholder: 'Escriba aquí su mensaje...'
      },
      closeConfirmation: {
        header: 'Confirme que desea finalizar',
        text1: '¿Está seguro de que desea finalizar la sesión actual?',
        text2:
          'Si cierra, se finalizará la sala definitivamente notificando a todos los participantes. No se podrá volver a acceder.',
        close: 'Cerrar sesión',
        continue: 'Prefiero continuar'
      }
    }
  },
  en: {
    message: {
      loading: {
        info: 'Loading resources, pleas wait...'
      },
      start: {
        connectionDisconected: 'Connection lost',
        connectionRecovered: 'You have connection again',
        connectionLost: 'You have lost connection'
      },
      waiting: {
        date: 'Date',
        startTime: 'Starting time',
        endTime: 'Ending time',
        welcomeAlert:
          'When joining you will be requested permissions to use your webcam and microphone. You will need to accept them in order to join the video call.',
        compatibilityAlert:
          'Your browser is not compatible with this conference system. Check the help guide.',
        roomEnded:
          'This video call has been closed by {role}. If you need a new appointment, please contact with your Medical Center. ',
        join: 'Join',
        delayRoom: 'Delay',
        connectionMaybeLost: 'Connection seems to be lost'
      },
      switching: {
        date: 'Date',
        startTime: 'Starting time',
        endTime: 'Ending time',
        message: 'Ready to switch devices'
      },
      help: {
        header: 'Help',
        audioVideoHelp: {
          title: 'How to enable video and audio permissions?',
          step1: 'Click on the lock which is on the navigation bar.',
          step2: 'It will show an information diagram as this one:',
          step3:
            'If the camara, microphone or sound are bloqued or denied, click over "Website configuration" and access to the next step:',
          step4:
            'Click over the element which is blocked and allow it to be used.',
          step5: 'Go back and join again.'
        },
        browserCompatibility: {
          title: 'Browser compatibility'
        }
      },
      videoCall: {
        doctor: 'Doctor',
        patient: 'Patient',
        guest: 'Guest',
        system: 'System',
        roomExpired: 'The room has expired',
        roomClosedByDoctor: 'The room has been closed by the doctor',
        roomClosedByPatient: 'The room has been closed by the patient',
        userDisconnected: '{role} has disconnected',
        userClosed: '{role} has closed',
        comunicationLost: 'Communication with {role} has been lost',
        notAllowedToJoin: 'You can´t join this room right now.',
        disconnected: 'You have been disconnected',
        closeRoom: 'You have closed the room.',
        unexpectedError: 'Unexpected error.',
        connectionError:
          'The connection could not been established. Please try again.',
        graceAlert:
          'The time of the appointment has ended. There are {remainingMinutes} courtesy minutes left',
        audioPermissionDenied:
          'You have denied the audio permissions. Please check out the help page to solve this problem.',
        videoPermissionDenied:
          'You have denied the video permissions. Please check out the help page to solve this problem.',
        permissionsDenied:
          'You have denied the audio or video permissions. Please check out the help page to solve this problem.',
        doctorMustHaveVideo:
          'In order to access as a doctor you need video support.',
        peerWithOnlyAudio: '{role} is connected without video',
        localTag: 'You',
        waitHeader: 'Wait a moment, pleae',
        waitText: 'Connecting your session'
      },
      delayNotification: {
        header: 'Delay notification',
        selectMinutes: 'Select the minutes of delay',
        send: 'Send notification',
        delayMessageSent: 'The delay notification has been sent',
        doctorDelayMessage:
          'The video consultation is {minutes} minutes late. Please stay tuned and sorry for the inconvenience.'
      },
      fileSharing: {
        header: 'Share files',
        fileSent: 'File {fileName} sent',
        fileReceived: 'File {fileName} received',
        thereAreNoFiles: 'There are no files',
        fileTooLarge: 'The file has exceeded the limit of {fileSizeLimit} MB'
      },
      chat: {
        header: 'Chat',
        placeholder: 'Write your message here...'
      },
      closeConfirmation: {
        header: 'Confirm that you want to finish',
        text1: 'Are you sure you want to end the current session?',
        text2:
          'If you close, the room will be permanently terminated and all participants notified. It will not be possible to access it again.',
        close: 'Close session',
        continue: 'I prefer continue'
      }
    }
  },
  fr: {
    message: {
      loading: {
        info: 'Chargement des ressources, veuillez patienter un instant...'
      },
      start: {
        connectionDisconected: 'Sans connexion',
        connectionRecovered: 'Reconnectez-vous',
        connectionLost: 'A perdu la connexion'
      },
      waiting: {
        date: 'Date',
        startTime: 'Heure de début',
        endTime: 'Heure de fin',
        welcomeAlert: `Lorsque vous vous inscrivez, il vous sera demandé la permission d'utiliser la caméra et le microphone, vous devez les accepter afin de faire la consultation vidéo. Chargez la batterie avant de commencer l'appel.`,
        compatibilityAlert: `Votre navigateur ne prend pas en charge le système d'interrogation. Veuillez vous référer à l'aide.`,
        roomEnded: `Cette consultation vidéo a été interrompue par le {role}. Si vous avez besoin d'un nouveau rendez-vous, veuillez contacter votre centre médical.`,
        join: 'Rejoignez',
        delayRoom: 'Retard',
        connectionMaybeLost: 'Il semble avoir perdu la connexion'
      },
      switching: {
        date: 'Date',
        startTime: 'Heure de début',
        endTime: 'Heure de fin',
        message: `Vous pouvez changer d'appareil`
      },
      help: {
        header: 'Aide',
        audioVideoHelp: {
          title: 'Comment activer les autorisations vidéo et audio ?',
          step1:
            'Cliquez sur le cadenas qui apparaît dans la barre de navigation.',
          step2: `Une boîte d'information comme celle ci-dessous sera affichée :`,
          step3: `Si la caméra, le microphone ou le son sont bloqués ou refusés, cliquez sur "Paramètres du site web" et vous accéderez à la vue suivante :`,
          step4: `Cliquez ensuite sur l'élément qui est verrouillé et autorisez son utilisation.`,
          step5: 'Retournez et entrez à nouveau dans la pièce.'
        },
        browserCompatibility: {
          title: 'Compatibilité des navigateurs'
        }
      },
      videoCall: {
        doctor: 'Facultatif',
        patient: 'Patient',
        guest: 'Invité',
        system: 'Système',
        roomExpired: 'La salle a expiré',
        roomClosedByDoctor: 'La salle a été fermée par le médecin',
        roomClosedByPatient: 'La salle a été fermée par le patient',
        userDisconnected: '{role} off',
        userClosed: '{role} a fermé',
        comunicationLost: 'La communication a été perdue avec {role}',
        notAllowedToJoin: 'Vous ne pouvez pas entrer dans la salle',
        disconnected: 'Vous avez perdu la connexion',
        closeRoom: 'Vous avez fermé la salle',
        unexpectedError: 'Erreur inattendue',
        connectionError: `La connexion n'a pas pu être établie. Essayez encore.`,
        graceAlert: `L'heure des rendez-vous est passée. Il reste {remainingMinutes} de courtoisie`,
        audioPermissionDenied: `Il s'est vu refuser les autorisations audio. Visitez la page d'aide pour résoudre ce problème.`,
        videoPermissionDenied: `Il s'est vu refuser des autorisations de tournage. Visitez la page d'aide pour résoudre ce problème.`,
        permissionsDenied: `Vous avez refusé l'autorisation d'utiliser un enregistrement audio ou vidéo. Visitez la page d'aide pour résoudre ce problème.`,
        doctorMustHaveVideo: `Vous devez disposer d'une vidéo pour pouvoir y accéder en option`,
        peerWithOnlyAudio: '{role} est connecté sans vidéo',
        localTag: 'Vous',
        waitHeader: `Attendez un moment s'il vous plaît`,
        waitText: 'Connecter votre session'
      },
      delayNotification: {
        header: 'Notification de retard',
        selectMinutes: 'Sélectionnez les minutes de retard',
        send: 'Envoyer une notification',
        delayMessageSent: 'La notification de retard a été envoyée',
        doctorDelayMessage:
          "La consultation vidéo a {minutes} minutes de retard. Veuillez rester à l'écoute et vous excuser pour la gêne occasionnée."
      },
      fileSharing: {
        header: 'Partage de fichiers',
        fileSent: 'Fichier {fileName} envoyé',
        fileReceived: 'Fichier {fileName} reçu',
        thereAreNoFiles: 'Aucun fichier',
        fileTooLarge: 'Le fichier a dépassé la limite de {fileSizeLimit} Mo'
      },
      chat: {
        header: 'Chat',
        placeholder: 'Ecrivez votre message ici ...'
      },
      closeConfirmation: {
        header: 'Confirmez que vous voulez terminer',
        text1: 'Voulez-vous vraiment mettre fin à la session en cours ?',
        text2: `Si elle ferme, la salle sera définitivement fermée en avertissant tous les participants. Il ne sera plus possible d'y accéder.`,
        close: 'Fermer la session',
        continue: 'Je préfère continuer'
      }
    }
  },
  gl: {
    message: {
      loading: {
        info: 'Cargando recursos, agarde un momento...'
      },
      start: {
        connectionDisconected: 'Sen conexión',
        connectionRecovered: 'Conéctate de novo',
        connectionLost: 'Perdeu a conexión'
      },
      waiting: {
        date: 'Data',
        startTime: 'Hora de inicio',
        endTime: 'Hora de finalización',
        welcomeAlert:
          'Ao unirse solicitarase permiso para usar a cámara e o micrófono, ten que aceptalos para poder facer a consulta de vídeo. Carga a batería antes de iniciar a chamada.',
        compatibilityAlert:
          'O seu navegador non admite o sistema de consulta. Ver axuda.',
        roomEnded:
          'O {role} rematou esta consulta de vídeo. Se precisa unha nova cita, póñase en contacto co seu centro médico.',
        join: 'Únete',
        delayRoom: 'Retraso',
        connectionMaybeLost: 'Parece que perdeu a conexión'
      },
      switching: {
        date: 'Data',
        startTime: 'Hora de inicio',
        endTime: 'Hora de finalización',
        message: 'Podes cambiar de dispositivo'
      },
      help: {
        header: 'Axuda',
        audioVideoHelp: {
          title: 'Como activar os permisos de vídeo e audio?',
          step1: 'Fai clic no candado que aparece na barra de navegación.',
          step2: 'Amosarase unha caixa de información como a seguinte:',
          step3:
            'Se a cámara, o micrófono ou o son están bloqueados ou negados, fai clic en "Configuración do sitio web" e accederá á seguinte vista:',
          step4:
            'Despois faga clic no elemento que está bloqueado e permita o seu uso.',
          step5: 'Volve e entra de novo na habitación.'
        },
        browserCompatibility: {
          title: 'Compatibilidade do navegador'
        }
      },
      videoCall: {
        doctor: 'Médico',
        patient: 'Paciente',
        guest: 'Invitado',
        system: 'Sistema',
        roomExpired: 'A sala caducou',
        roomClosedByDoctor: 'A habitación foi pechada polo médico',
        roomClosedByPatient: 'A habitación foi pechada polo paciente',
        userDisconnected: '{role} sen conexión',
        userClosed: '{role} pechou',
        comunicationLost: 'Perdeuse a comunicación con {role}',
        notAllowedToJoin: 'Non se pode entrar na habitación',
        disconnected: 'Perdeu a conexión',
        closeRoom: 'Peches a habitación',
        unexpectedError: 'Erro inesperado',
        connectionError:
          'Non se puido establecer a conexión. Inténtao de novo.',
        graceAlert:
          'O horario de cita finalizou. Restan {remainingMinutes} minutos de cortesía',
        audioPermissionDenied:
          'Vostede denegou os permisos de audio. Axuda de visita para solucionalo.',
        videoPermissionDenied:
          'Vostede denegou os permisos de vídeo. Axuda de visita para solucionalo.',
        permissionsDenied:
          'Vostede denegou os permisos de audio ou vídeo. Axuda de visita para solucionalo.',
        doctorMustHaveVideo: 'Para acceder como médico debes ter un vídeo',
        peerWithOnlyAudio: '{role} está en liña sen vídeo',
        localTag: 'Seu',
        waitHeader: 'Agarde un momento, por favor',
        waitText: 'Conectando a súa sesión'
      },
      delayNotification: {
        header: 'Notificación de atraso',
        selectMinutes: 'Seleccione os minutos de atraso',
        send: 'Envía unha notificación',
        delayMessageSent: 'Enviouse a notificación de atraso',
        doctorDelayMessage:
          'A consulta de vídeo chega con {minutes} minutos. Mantéñase atento e pide desculpas polas molestias.'
      },
      fileSharing: {
        header: 'Compartir de ficheiros',
        fileSent: 'Enviado o ficheiro {fileName}',
        fileReceived: 'Recibiu o ficheiro {fileName}',
        thereAreNoFiles: 'Non hai ficheiros',
        fileTooLarge: 'O ficheiro superou o límite de {fileSizeLimit} MB'
      },
      chat: {
        header: 'Chat',
        placeholder: 'Escribe a túa mensaxe aquí ...'
      },
      closeConfirmation: {
        header: 'Confirma que queres rematar',
        text1: '¿Estás seguro de que queres finalizar a sesión actual?',
        text2:
          'Se se pecha, a sala darase por finalizada definitivamente avisando a todos os participantes. Non será posible acceder de novo a el.',
        close: 'Asinar',
        continue: 'Prefiro continuar'
      }
    }
  },
  ca: {
    message: {
      loading: {
        info: 'Carregant recursos, si us plau espereu un moment...'
      },
      start: {
        connectionDisconected: 'Sense connexió',
        connectionRecovered: 'Torna a tenir connexió',
        connectionLost: 'Ha perdut la connexió'
      },
      waiting: {
        date: 'Data',
        startTime: `Hora d'inici`,
        endTime: `Hora de fi`,
        welcomeAlert: `A l'unir-se se li demanarà permís per utilitzar la càmera i el micròfon, cal acceptar-los per poder realitzar la vídeo consulta. Carregueu la bateria abans d'iniciar la trucada.`,
        compatibilityAlert: `El seu navegador no és compatible amb el sistema de consultes. Consulteu l'ajuda.`,
        roomEnded: `Aquesta vídeo consulta ha estat finalitzada pel {role}. Si necessita una nova cita, si us plau contacti amb el seu centre mèdic.`,
        join: 'Unir-se',
        delayRoom: 'Endarrerir',
        connectionMaybeLost: 'Sembla haver perdut la connexió'
      },
      switching: {
        date: 'Data',
        startTime: `Hora d'inici`,
        endTime: `Hora de fi`,
        message: 'Podeu canviar de dispositiu'
      },
      help: {
        header: 'Ajuda',
        audioVideoHelp: {
          title: 'Com activar permisos de vídeo i àudio?',
          step1: `Faci clic sobre el cadenat que apareix a la barra de navegació.`,
          step2: `Es mostrarà un quadre d'informació com el següent:`,
          step3:
            'Si la càmera, micròfon o so està bloquejat o denegat, feu clic sobre "Configuració del lloc web" i accedirà a la següent vista:',
          step4: `A continuació feu clic sobre l'element que està bloquejat i permeti el seu ús.`,
          step5: 'Torneu enrere i entri en la sala de nou.'
        },
        browserCompatibility: {
          title: 'Compatibilitat de navegadors'
        }
      },
      videoCall: {
        doctor: 'Facultatiu',
        patient: 'Pacient',
        guest: 'Convidat',
        system: 'Sistema',
        roomExpired: 'La sala ha expirat',
        roomClosedByDoctor: 'La sala ha estat tancada pel facultatiu',
        roomClosedByPatient: 'La sala ha estat tancada pel pacient',
        userDisconnected: '{role} desconnectat',
        userClosed: '{role} ha tancat',
        comunicationLost: `S'ha perdut la comunicació amb {role}`,
        notAllowedToJoin: 'No pot entrar a la sala',
        disconnected: 'Has perdut la connexió',
        closeRoom: 'Has tancat la sala',
        unexpectedError: 'Error inesperat',
        connectionError: `No s'ha pogut establir la connexió. Proveu de nou.`,
        graceAlert: `L'hora de la cita ha finalitzat. Queden {remainingMinutes} minuts de cortesia`,
        audioPermissionDenied: `Ha denegat els permisos d'àudio. Visiteu l'ajuda per solucionar-ho.`,
        videoPermissionDenied: `Ha denegat els permisos de vídeo. Visiteu l'ajuda per solucionar-ho.`,
        permissionsDenied: `Ha denegat els permisos d'àudio o vídeo. Visiteu l'ajuda per solucionar-ho.`,
        doctorMustHaveVideo:
          'Per poder accedir com a facultatiu ha de tenir vídeo',
        peerWithOnlyAudio: '{role} està connectat sense vídeo',
        localTag: 'Tu',
        waitHeader: 'Si us plau, espereu un moment',
        waitText: 'Connectant la sessió'
      },
      delayNotification: {
        header: 'Notificació de retard',
        selectMinutes: 'Seleccioneu els minuts de retard',
        send: 'Enviar notificació',
        delayMessageSent: 'La notificació de retard ha estat enviada',
        doctorDelayMessage:
          'La videoconsulta porta {minutes} minuts de retard. Si us plau estigui atent i disculpi les molèsties.'
      },
      fileSharing: {
        header: 'Compartir fitxers',
        fileSent: 'Fitxer {fileName} enviat',
        fileReceived: 'Fitxer {fileName} rebut',
        thereAreNoFiles: 'No hi ha fitxers',
        fileTooLarge: 'El fitxer ha superat el límit de {fileSizeLimit} MB'
      },
      chat: {
        header: 'Xat',
        placeholder: 'Escrigui aquí el seu missatge...'
      },
      closeConfirmation: {
        header: 'Confirmeu que voleu finalitzar',
        text1: '¿Esteu segur que voleu finalitzar la sessió actual?',
        text2:
          'Si tanca, la sala es finalitzarà definitivament notificant a tots els participants. No es podrà tornar a accedir.',
        close: 'Tancar sessió',
        continue: 'Prefereixo continuar'
      }
    }
  },
  eu: {
    message: {
      loading: {
        info: 'Baliabideak kargatzen, itxaron une bat...'
      },
      start: {
        connectionDisconected: 'Konexiorik gabe',
        connectionRecovered: 'Sartu berriro sarean',
        connectionLost: 'Konexioa galdu du'
      },
      waiting: {
        date: 'Data',
        startTime: 'Hasiera ordua',
        endTime: 'Amaiera ordua',
        welcomeAlert:
          'Bat egitean, kamera eta mikrofonoa erabiltzeko baimena eskatuko zaizu, onartu egin behar dituzu bideo kontsulta egiteko. Kargatu bateria deia hasi aurretik.',
        compatibilityAlert:
          'Zure arakatzaileak ez du kontsulta sistema onartzen. Ikusi laguntza.',
        roomEnded:
          'Bideo-kontsulta hau amaitu du {role}. Hitzordu berria behar baduzu, jarri harremanetan zure mediku zentroarekin.',
        join: 'Parte hartu',
        delayRoom: 'Atzerapena',
        connectionMaybeLost: 'Konexioa galdu duela dirudi'
      },
      switching: {
        date: 'Data',
        startTime: 'Hasiera ordua',
        endTime: 'Amaiera ordua',
        message: 'Gailuz alda dezakezu'
      },
      help: {
        header: 'Laguntza',
        audioVideoHelp: {
          title: 'Nola aktibatu bideo eta audio baimenak?',
          step1: 'Egin klik nabigazio barran agertzen den giltzarrapoan.',
          step2: 'Honako hau bezalako informazio-laukia bistaratuko da:',
          step3:
            'Kamera, mikrofonoa edo soinua blokeatuta edo ukatuta badago, egin klik "Webgunearen konfigurazioan" eta ondorengo ikuspegira sartuko zara:',
          step4:
            'Ondoren, egin klik blokeatuta dagoen elementuan eta baimendu bere erabilera.',
          step5: 'Itzuli eta sartu berriro gelan.'
        },
        browserCompatibility: {
          title: 'Arakatzailearen bateragarritasuna'
        }
      },
      videoCall: {
        doctor: 'Medikua',
        patient: 'Gaixoaren',
        guest: 'Gonbidatuak',
        system: 'Sistemak',
        roomExpired: 'Gela iraungi egin da',
        roomClosedByDoctor: 'Gela medikuak itxi du',
        roomClosedByPatient: 'Gela gaixoarenak itxi du',
        userDisconnected: '{rol} lineaz kanpo',
        userClosed: '{rol} itxi da',
        comunicationLost: 'Komunikazioa galdu egin da {role}',
        notAllowedToJoin: 'Ezin da gelan sartu',
        disconnected: 'Konexioa galdu duzu',
        closeRoom: 'Gela itxi duzu',
        unexpectedError: 'Ustekabeko errorea',
        connectionError: 'Ezin izan da konexioa ezarri. Saiatu berriro.',
        graceAlert:
          'Hitzordua amaitu da. {remainingMinutes} atsegin-minutu falta dira',
        audioPermissionDenied:
          'Audio baimenak ukatu dituzu. Bisitatu laguntza konpontzen.',
        videoPermissionDenied:
          'Bideo baimenak ukatu dituzu. Bisitatu laguntza konpontzen.',
        permissionsDenied:
          'Audio- edo bideo baimenak ukatu dituzu. Bisitatu laguntza konpontzen.',
        doctorMustHaveVideo: 'Mediku gisa sartzeko bideo bat izan behar duzu',
        peerWithOnlyAudio: '{rol} bideoa gabe linean dago',
        localTag: 'Zure',
        waitHeader: 'Itxaron momentu bat mesedez',
        waitText: 'Zure saioa konektatzen'
      },
      delayNotification: {
        header: 'Atzerapena jakinaraztea',
        selectMinutes: 'Hautatu atzerapen minutuak',
        send: 'Bidali jakinarazpena',
        delayMessageSent: 'Atzerapen jakinarazpena bidali da',
        doctorDelayMessage:
          'Bideoaren kontsulta {minutes} minutu atzeratzen da. Mesedez, adi egon eta barkatu barkatu eragozpenak.'
      },
      fileSharing: {
        header: 'Fitxategiak partekatzea',
        fileSent: '{FileName} fitxategia bidali da',
        fileReceived: '{FileName} fitxategia jaso da',
        thereAreNoFiles: 'Ez dago fitxategirik',
        fileTooLarge: 'Fitxategiak {fileSizeLimit} MB-ren muga gainditu du'
      },
      chat: {
        header: 'Chat',
        placeholder: 'Idatzi hemen zure mezua ...'
      },
      closeConfirmation: {
        header: 'Berretsi amaitu nahi duzula',
        text1: 'Ziur oraingo saioa amaitu nahi duzula?',
        text2:
          'Itxiz gero, aretoa behin betiko amaituko da parte hartzaile guztiei jakinaraziz. Ezin izango da berriro sartu.',
        close: 'Saioa itxi',
        continue: 'Nahiago dut jarraitu'
      }
    }
  }
};
